import React from 'react'
import { ElementProps } from '../base/element'

import {
  IContainerComponent,
  IDefaultStyles,
  IStyles
} from '../schemamanager/types'

export interface IToolbarComponent extends IContainerComponent {
  type: 'toolbar'
  label?: string
  styleLabel?: IStyles
  styleChildren?: IStyles
}

const style: IDefaultStyles = {
  main: {
    classes: {
      display: 'flex',
      alignItems: 'items-center',
      padding: 'p-1',
      borderRadius: 'rounded',
      overflow: 'overflow-hidden',
      boxShadow: 'shadow-sm'
    }
  },
  styleLabel: {
    classes: {
      margin: 'ml-2',
      fontSize: 'text-xl',
      fontWeight: 'font-bold'
    }
  },
  styleChildren: {
    classes: {
      margin: 'ml-auto',
      padding: 'p-1'
    }
  }
}

export const Toolbar = (props: ElementProps) => {
  const { children } = props
  const comp = props.comp as IToolbarComponent
  const m = props.mergeStyles(style)

  return (
    <div {...m.main} {...props.events()}>
      <div {...m.styleLabel}>{comp.label}</div>
      <div {...m.styleChildren}>{children}</div>
    </div>
  )
}
